import { compress, decompress } from 'lz-string';

export const DEFAULT_EXPOSITION_ID = '123456'

export const EXPOSITION_ID_LENGTH = 6;

const LZW_COMPRESSION = true;

export function createSessionIdentifier() {

  const lengthInDigits = EXPOSITION_ID_LENGTH;
  const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';

  let id = '';

  for(let k=0; k<lengthInDigits; k++) {
    const index = Math.floor(Math.random() * alphabet.length);
    id += alphabet[index];
  }

  return id;
}

export function encodeJSON(data:any) {
  const clean = JSON.stringify(data);
  const compressed = LZW_COMPRESSION ? compress(clean) : clean;
  return compressed.toString();
}

export function decodeJSON(data:any) {
  const decompressed = LZW_COMPRESSION ? decompress(data.toString()) : data.toString();
  return JSON.parse(decompressed);
}

export function html_encode(str:string) {
  let i = str.length,
      aRet = [];
  while (i--) {
    let iC = str.charCodeAt(i);
    if (iC < 65 || iC > 127 || (iC>90 && iC<97)) {
      aRet[i] = '&#'+iC+';';
    } else {
      aRet[i] = str[i];
    }
  }
  return aRet.join('');
}

export function generateDateTimeString(): string {

  const date = new Date();

  const year = date.getFullYear() - 2000

  const monthNr = date.getMonth() + 1;
  const month = (monthNr + '').length < 2 ? `0${monthNr}` : monthNr;

  const dayNr = date.getDate();
  const day = (dayNr + '').length < 2 ? `0${dayNr}` : dayNr;
  
  const hoursNr = date.getHours();
  const hours = (hoursNr + '').length < 2 ? `0${hoursNr}` : hoursNr;

  const minutesNr = date.getMinutes();
  const minutes = (minutesNr + '').length < 2 ? `0${minutesNr}` : minutesNr;

  const str = `${year}${month}${day}-${hours}${minutes}`

  return str;
}


// src: https://stackoverflow.com/questions/8609289/convert-a-binary-nodejs-buffer-to-javascript-arraybuffer
export function toJavaScriptBuffer(arrayBuffer: ArrayBuffer) {
  let jsBuffer = Buffer.alloc(arrayBuffer.byteLength);
  let chunk = new Uint8Array(arrayBuffer);
  for (let i = 0; i < jsBuffer.length; ++i) {
      jsBuffer[i] = chunk[i];
  }
  return jsBuffer;
}
